import { render, staticRenderFns } from "./TrayCloser.vue?vue&type=template&id=9851b81c&"
import script from "./TrayCloser.vue?vue&type=script&lang=ts&"
export * from "./TrayCloser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports